import TextMetricController from '../../controllers/TextMetricController';
import NotificationController from '../../controllers/NotificationController';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { NotificationViewGrid } from './NotificationViewGrid';
import { isDesktop } from 'react-device-detect';
let scale = isDesktop ? 1 : 2;
export const NotificationView = {
	name: COMPONENTS.NOTIFICATION,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: TextMetricController,
			name: 'TextMetricController',
			config: {
				item: 'notif_bg',
				val: 'notif_bg',
				position: { x: 0, y: 0, w: 634 },
				texts: [
					{
						value: 'notif_title',
						position: { x: 0, y: 30 },
						maxLineWidth: 1,
						wordWrap: false
					},
					{
						value: 'notif_desc',
						position: { x: 0, y: 120 },
						maxLineWidth: 1.8,
						wordWrap: true
					}
				]
			}
		},
		{
			Controller: NotificationController,
			name: 'NotificationController',
			config: {
				item: 'notif_bg',
				holder: 'notif_bg'
			}
		},
		{
			Controller: MainGridController,
			name: 'NotificationGridController',
			config: NotificationViewGrid
		}
	],
	components: [
		{
			name: 'notif_bg',
			type: 'Sprite',
			components: [
				{
					name: 'notif_bg',
					type: 'Sprite',
					img: 'notif_bg',
					alpha: 0.8,
					scale: { x: scale, y: scale }
				},
				{
					name: 'notif_title',
					type: 'Text',
					text: 'NOTIFICATION_HEADER',
					position: { x: 0, y: 0 }
				},
				{
					name: 'notif_desc',
					type: 'Text',
					text: 'NOTIFICATION_DESC',
					position: { x: 0, y: 0 }
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'notif_btn',
					text: 'NOTIFICATION_BTN',
					position: { x: 316, y: 294 }
				}
			]
		}
	]
};
